export const imports = {
  'CONTRIBUTING.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "contributing" */ 'CONTRIBUTING.md'
    ),
  'LICENSE.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "license" */ 'LICENSE.md'
    ),
  'README.md': () =>
    import(/* webpackPrefetch: true, webpackChunkName: "readme" */ 'README.md'),
  'packages/eslint-config-ableneo/CHANGELOG.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-eslint-config-ableneo-changelog" */ 'packages/eslint-config-ableneo/CHANGELOG.md'
    ),
  'packages/eslint-config-ableneo/README.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-eslint-config-ableneo-readme" */ 'packages/eslint-config-ableneo/README.md'
    ),
  'packages/hygen-eslint-config-ableneo/CHANGELOG.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-hygen-eslint-config-ableneo-changelog" */ 'packages/hygen-eslint-config-ableneo/CHANGELOG.md'
    ),
  'packages/hygen-eslint-config-ableneo/README.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-hygen-eslint-config-ableneo-readme" */ 'packages/hygen-eslint-config-ableneo/README.md'
    ),
  'packages/prettier-config/CHANGELOG.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-prettier-config-changelog" */ 'packages/prettier-config/CHANGELOG.md'
    ),
  'packages/prettier-config/README.md': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "packages-prettier-config-readme" */ 'packages/prettier-config/README.md'
    ),
}
